import React from 'react';
import '../styles/preloader.css';

/**
 * Универсальный прелоадер для состояний загрузки данных.
 * size: 'md' (по умолчанию) — для контентной области страницы,
 *       'sm' — компактный, для секций/списков внутри страницы.
 */
const Preloader = ({ size = 'md', label = '', className = '' }) => (
  <div
    className={`preloader preloader--${size}${className ? ` ${className}` : ''}`}
    role="status"
    aria-live="polite"
    aria-label={label || 'Loading'}
  >
    <span className="preloader__spinner" />
    {label && <span className="preloader__label">{label}</span>}
  </div>
);

export default Preloader;
